package team.platforma.multiplatform_material_extension.tab_row.style

import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.TabPosition
import androidx.compose.material3.TabRowDefaults
import androidx.compose.material3.TabRowDefaults.tabIndicatorOffset
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

object AdaptiveTabRowStyle {
    private var mTab: Tab = Tab()
    private var mTabRow: TabRow = TabRow()
    @Composable
    fun define(
        tab: Tab = Tab(),
        tabRow :TabRow = TabRow()
    ) {
        mTab = tab
        mTabRow = tabRow
    }

    @Composable
    fun tab(): Tab {
       return mTab
    }

    @Composable
    fun tabRow(): TabRow {
        return mTabRow
    }

}

data class Tab(
    val indicator: @Composable (tabPositions: List<TabPosition>, selectedTabIndex: Int, list: List<Any>) -> Unit = { tabPositions, selectedTabIndex, list ->
        TabRowDefaults.SecondaryIndicator(Modifier.tabIndicatorOffset(tabPositions[selectedTabIndex]))
    },
    val defaultTabModifier: Modifier = Modifier,
    val checkedTabModifier: Modifier = defaultTabModifier,
    val selectedContentColor: Color = Color.Unspecified,
    val unselectedContentColor: Color = Color.Unspecified
)

data class TabRow(
    val containerColor : Color = Color.Transparent,
    val contentColor : Color = Color.Transparent,
    val divider: @Composable () -> Unit = { HorizontalDivider() },
    val edgePadding : Dp = 16.dp,
    val customTabPadding: Dp = 0.dp
)